import { Injectable } from '@angular/core';
import { Constants } from '../../../../common/constants';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { O2RegionalAnalysis, O2RegionalAnalysisFull } from "../types/O2RegionalAnalysis";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class O2PortalHycoReportService {
  constructor(protected http: HttpClient) {
  }

  baseurl = environment.apiBaseUrl + 'O2PortalHyCoAnalysisReport';

  setReportCalendarYearFilterLabel(linkId: number) {
    let yearDropdownLabelText: string = "";
    switch (linkId) {
      case 2:
        yearDropdownLabelText = Constants.FiveYearHyCoReportAnalysisFilterLabelText
        break;
      case 3:
      default:
        yearDropdownLabelText = Constants.OneYearHyCoReportAnalysisFilterLabelText
        break;
    }
    return yearDropdownLabelText;
  }

  getPageTitle(linkId: number) {
    let pageTitle: string = "";
    switch (linkId) {
      case 1:
        pageTitle = Constants.OneYearAnalysisHyCoReportPageTitleText
        break;
      case 2:
        pageTitle = Constants.FiveYearAnalysisHyCoReportPageTitleText
        break;
      case 3:
        pageTitle = Constants.RegionalAnalysisHyCoReportPageTitleText
        break;
      case 4:
        pageTitle = Constants.AwardDetailsHyCoReportPageTitleText
        break;
      default:
        pageTitle = Constants.OneYearAnalysisHyCoReportPageTitleText
        break;
    }
    return pageTitle;
  }

  getHyCoReportCalendarYears() {
    return this.http.get<any[]>(this.baseurl + '/awardAnnouncementYears');
  }

  getHyCoAnalysisReportData(reportId: number, announcementYear: number) {
    return this.http.get<any[]>(this.baseurl + '/' + reportId + '/' + announcementYear);
  }

  getRegionalAnalysisReportData(announcementYear: number): Observable<O2RegionalAnalysis[]> {
    return this.http.get<O2RegionalAnalysis[]>(this.baseurl + '/regionalanalysis/' + announcementYear);
  }

  getFullRegionalAnalysisReportData(announcementYear: number): Observable<O2RegionalAnalysisFull[]> {
    return this.http.get<O2RegionalAnalysisFull[]>(this.baseurl + '/regionalanalysisfull/' + announcementYear);
  }
  
  getAwardDetails(selectedAnnouncementYear: number, noOfyear) {
    return this.http.get<any[]>(this.baseurl + '/getawarddetails/' + selectedAnnouncementYear + "/" + noOfyear);
  }
}